import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import { DownloadAxiosFile } from 'utils'

import { SelectMesContabilidad } from 'sharedComponents/select'

import * as CentrosCostosService from 'services/centrosCosto.service'

const ReporteModuloCosto = () => {
  const [desdeMes, setDesdeMes] = React.useState('')
  const [hastaMes, setHastaMes] = React.useState('')

  const __zariContext = React.useContext(ZariContext)

  const clickDescargarReporte = React.useCallback(() => {
    const parsedDesde = parseFloat(desdeMes)
    const parsedHasta = parseFloat(hastaMes)

    if (parsedDesde > parsedHasta) {
      __zariContext.snack('warning', 'El mes final no puedes ser inferior a mes inicial.')
      return
    }

    __zariContext.loader.open('Descargando Reporte Cruce Clase 6...')
    CentrosCostosService.descargarReporteCruceClase6({ desde: desdeMes, hasta: hastaMes })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [desdeMes, __zariContext, hastaMes])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Cruce Clase 6' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Desde' md={4} alignRightAt='md' />
              <Col md={8}>
                <SelectMesContabilidad
                  id='select-mes-desde'
                  name='select-mes-desde'
                  value={desdeMes}
                  onChange={e => {
                    setDesdeMes(e.target.value)
                    setHastaMes(e.target.value)
                  }}
                />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Hasta' md={4} alignRightAt='md' />
              <Col md={8}>
                <SelectMesContabilidad id='select-mes-hasta' name='select-mes-hasta' value={hastaMes} onChange={e => setHastaMes(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReporteModuloCosto)
